// Programs unlock from the v2.4 line onward (inclusive).
const PROGRAMS_MIN = { major: 2, minor: 4 };

// Gate on the numeric major.minor line so every 2.4 build (RC, patch, or final) qualifies; RC-vs-release ordering never affects the boundary, which sits between lines.
export function isProgramsVersion(version: string | undefined): boolean {
	const match = version?.match(/^v?(\d+)\.(\d+)/i);
	if (!match) return false;
	const major = Number(match[1]);
	const minor = Number(match[2]);
	return (
		major > PROGRAMS_MIN.major || (major === PROGRAMS_MIN.major && minor >= PROGRAMS_MIN.minor)
	);
}

// Programs store their SafeCurves version as `v{series}` (`program.safecurvesVersion`).
export const programVersionTag = (series: string): string => `v${series}`;

// The data series (as on versions rows and WFS layers) a program's version tag points at.
export const programSeries = (tag: string): string => tag.replace(/^v/i, '');
